var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FirebaseMessage'),(_vm.isMobile)?_c('div',[_c('OrderListMobile')],1):_c('div',[_c('OrderListDesktop')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }